import { Component, Input, inject } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { SHARED_STANDALONE_IMPORTS } from 'app/shared/standalone-imports';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  standalone: true,
  imports: [...SHARED_STANDALONE_IMPORTS],
})
export class InfoModalComponent {
  private modalCtrl = inject(ModalController);
  @Input() text: string = '';
  @Input() formatHtml: boolean = false;
  @Input() isError: boolean = false;

  public cancel(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      return this.modalCtrl.dismiss(null, null);
    }
  }

  public clickFormattedHtmlText(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      return this.modalCtrl.dismiss(null, 'cancel');
    }
  }
}
